import { render, staticRenderFns } from "./FormRechazo.vue?vue&type=template&id=8a491e0a&"
import script from "./FormRechazo.vue?vue&type=script&lang=js&"
export * from "./FormRechazo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports